export function rampColor2legend(rampColors, name) {
  return {
    type: rampColors.type,
    field: 'value',
    items: rampColors.positions.map((value, index) => {
      return {
        [name]: index >= rampColors.colors.length ? null : rampColors.colors[index],
        value
      };
    })
  };
}